// extracted by mini-css-extract-plugin
export default {"wrapper":"OC-z","viewport":"PC-z","container":"QC-z","slide":"RC-z"};